import SearchScreen from "..\\..\\..\\..\\src\\screens\\search";
import React from 'react';
export default {
  SearchScreen,
  React
};